const initialState = {
    data: 42
}


const testReducer = (state = initialState, action) => {
    return state;
}


export default testReducer;


// WEBPACK FOOTER //
// ./src/app/reducers/testReducer.js